import * as types from './types';
import { Metadata } from '../../models/metadata';
import axios from 'axios';

export const updateMetaData = (metadata) => ({
  type: types.UPDATE_METADATA,
  payload: { metadata },
});

export const subscriptionMetadataLoading = (isLoading) => ({
  type: types.METADATA_LOADING,
  payload: { isLoading },
});

export const subscriptionMetadataSuccess = (metadata) => ({
  type: types.METADATA_LOADED_SUCCESSFULLY,
  payload: { metadata: new Metadata(metadata) },
});

export const getSubscriptionMetadata = ({ subscriptionId, signature }) => {
  return async (dispatch, getState) => {
    dispatch(subscriptionMetadataLoading(true));
    const language = getState().appState.language;
    return axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/payments/meta`, {
        params: { subscription_id: subscriptionId, signature },
        headers: { 'Accept-Language': language },
      })
      .then((res) => {
        dispatch(
          subscriptionMetadataSuccess({
            type: res.data.type,
            ...res.data.meta,
            subscription_id: subscriptionId,
          }),
        );
      })
      .finally(() => {
        dispatch(subscriptionMetadataLoading(false));
      });
  };
};

export const calculatePrice = ({ bankBin } = {}) => {
  return async (dispatch, getState) => {
    const { language, token } = getState().appState;
    const {
      planId,
      addressId,
      voucherCode,
      addonId,
      isPaidWithWallet,
      mokafaaTransactionId,
    } = getState().metadata.object;

    return axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/checkout/calculate-price`, {
        params: {
          plan_id: planId,
          address_id: addressId,
          voucher_code: voucherCode,
          bank_bin: bankBin,
          ...(addonId && { addon_id: addonId }),
          pay_with_wallet: isPaidWithWallet,
          ...(mokafaaTransactionId && {
            mokafaa_transaction_id: String(mokafaaTransactionId),
          }),
        },
        headers: {
          'Accept-Language': language,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const priceInformation = res.data?.data?.price_information;

        const newMetadata = {
          ...getState().metadata.object.toJSON(),
          ...priceInformation,
        };

        dispatch(updateMetaData(new Metadata(newMetadata)));
      });
  };
};

export const updateSubscription = ({ subscriptionId, bankBin } = {}) => {
  return async (dispatch, getState) => {
    const { language, token } = getState().appState;
    const { voucherCode, addonId, isPaidWithWallet, mokafaaTransactionId } =
      getState().metadata.object;

    return axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/subscription/${subscriptionId}`,
      {
        ...(voucherCode && { voucher_code: voucherCode }),
        ...(bankBin && { bank_bin: bankBin }),
        ...(addonId && { addon_id: addonId }),
        pay_with_wallet: isPaidWithWallet,
        ...(mokafaaTransactionId && {
          mokafaa_transaction_id: String(mokafaaTransactionId),
        }),
      },
      {
        headers: {
          'Accept-Language': language,
          Authorization: `Bearer ${token}`,
        },
      },
    );
  };
};
